import React, { useEffect, useRef, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/about.css';

const UniTrack = () => {
  const underlineRef = useRef(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const t = setTimeout(() => underlineRef.current && underlineRef.current.classList.add('animate'), 50);
    return () => clearTimeout(t);
  }, []);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setMousePosition({ x, y });
  };

  return (
    <>
      <style>
        {`
          @keyframes scan {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes blink {
            0%, 90%, 100% { transform: scaleY(1); }
            95% { transform: scaleY(0.1); }
          }
          @keyframes sweep {
            0% { transform: translateY(-100%); }
            100% { transform: translateY(100%); }
          }
          @keyframes moveBg {
            0% { background-position: 0 0, 0 0; }
            100% { background-position: 400px 0, -400px 0; }
          }
          .ai-eye .eyelid {
            transform-origin: center;
            animation: blink 4s infinite;
          }
        `}
      </style>
      <div 
        className="container-fluid about-bg d-flex align-items-end" 
        style={{ 
          minHeight: '85vh', 
          padding: 0, 
          top: '-122px',
          position: 'relative',
          overflow: 'hidden'
        }}
        onMouseMove={handleMouseMove}
      >
        {/* Neon Grid + Gradient Background */}
        <div 
          className="camera-bg"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: `
              linear-gradient(135deg, rgba(14, 42, 92, 0.9), rgba(20, 66, 144, 0.9)),
              repeating-linear-gradient(90deg, rgba(66,165,245,.08) 0 1px, transparent 1px 40px),
              repeating-linear-gradient(0deg, rgba(66,165,245,.06) 0 1px, transparent 1px 40px)
            `,
            backgroundBlendMode: 'overlay',
            animation: 'moveBg 6s linear infinite',
            zIndex: 1
          }}
        />

        {/* Faster Scanning Lines Effect */}
        <div
          className="scanning-lines"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: `
              repeating-linear-gradient(
                0deg,
                transparent,
                transparent 1px,
                rgba(255, 255, 255, 0.04) 1px,
                rgba(255, 255, 255, 0.04) 3px
              )
            `,
            zIndex: 2
          }}
        />
        {/* Vertical sweep beam */}
        <div
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '40%',
            background: 'linear-gradient(180deg, rgba(255,255,255,.05), rgba(255,255,255,0))',
            filter: 'blur(1px)',
            animation: 'sweep 2.5s linear infinite',
            zIndex: 2
          }}
        />
        
        {/* Center Character Head with realistic eyes */}
        <div
          style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: `translate(-50%, -50%) rotateX(${Math.max(Math.min((mousePosition.y - window.innerHeight/2) / 60, 10), -10)}deg) rotateY(${Math.max(Math.min(-(mousePosition.x - window.innerWidth/2) / 60, 12), -12)}deg)` ,
            transformStyle: 'preserve-3d',
            width: '260px',
            height: '260px',
            zIndex: 3,
            pointerEvents: 'none'
          }}
        >
          {/* Head */}
          <div
            style={{
              position: 'absolute',
              inset: 0,
              borderRadius: '50%',
              background: 'radial-gradient(circle at 50% 35%, #f2f2f2 0%, #e6e6e6 45%, #cfcfcf 70%, #bdbdbd 100%)',
              boxShadow: '0 30px 80px rgba(0,0,0,0.35), inset 0 -12px 30px rgba(0,0,0,0.15), inset 0 12px 24px rgba(255,255,255,0.25)'
            }}
          />
          {/* Face shadow */}
          <div
            style={{
              position: 'absolute',
              left: '50%',
              top: '55%',
              transform: 'translate(-50%, -50%)',
              width: '85%',
              height: '70%',
              borderRadius: '50%',
              background: 'radial-gradient(ellipse at 50% 40%, rgba(0,0,0,0.08) 0%, rgba(0,0,0,0.03) 55%, transparent 70%)'
            }}
          />
          {/* Eyes container */}
          <div
            style={{
              position: 'absolute',
              top: '42%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '72%',
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            {[0,1].map((i) => (
              <div key={i} style={{ position: 'relative', width: 68, height: 44 }}>
                {/* Eye socket */}
                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: 26,
                    background: 'linear-gradient(180deg, #ffffff 0%, #f3f6fb 60%, #e3e9f3 100%)',
                    boxShadow: 'inset 0 2px 6px rgba(0,0,0,0.15), 0 6px 14px rgba(0,0,0,0.15)'
                  }}
                />
                {/* Iris */}
                <div
                  style={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: `translate(calc(-50% + ${Math.max(Math.min((mousePosition.x - window.innerWidth/2) / 30, 10), -10)}px), calc(-50% + ${Math.max(Math.min((mousePosition.y - window.innerHeight/2) / 30, 8), -8)}px))`,
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    background: 'radial-gradient(circle at 50% 50%, #0b4ea3 0%, #0c61c0 45%, #043a7a 65%, #001a3a 100%)',
                    boxShadow: '0 0 14px rgba(12,97,192,0.5), inset 0 0 10px rgba(0,0,0,0.35)'
                  }}
                >
                  {/* Pupil */}
                  <div style={{ position: 'absolute', inset: '6px', borderRadius: '50%', background: 'radial-gradient(circle, #000 0%, #111 60%, #222 100%)' }} />
                  {/* Highlights */}
                  <div style={{ position: 'absolute', top: 2, left: 6, width: 7, height: 7, borderRadius: '50%', background: 'rgba(255,255,255,0.9)' }} />
                  <div style={{ position: 'absolute', top: 10, left: 12, width: 4, height: 4, borderRadius: '50%', background: 'rgba(255,255,255,0.7)' }} />
                </div>
                {/* Upper eyelid (blinking) */}
                <div className="eyelid" style={{ position: 'absolute', top: -2, left: 0, right: 0, height: 24, borderTopLeftRadius: 26, borderTopRightRadius: 26, background: 'linear-gradient(180deg, rgba(210,215,225,0.9), rgba(210,215,225,0))' }} />
                {/* Bottom eyelid shine */}
                <div style={{ position: 'absolute', bottom: -1, left: 0, right: 0, height: 10, borderBottomLeftRadius: 26, borderBottomRightRadius: 26, background: 'linear-gradient(0deg, rgba(255,255,255,0.8), rgba(255,255,255,0))' }} />
              </div>
            ))}
          </div>
          {/* Simple nose hint */}
          <div style={{ position: 'absolute', left: '50%', top: '56%', transform: 'translateX(-50%)', width: 18, height: 22, borderRadius: '50%', background: 'radial-gradient(ellipse at 50% 20%, rgba(0,0,0,0.08) 0%, rgba(0,0,0,0.02) 80%, transparent 100%)' }} />
          {/* Subtle mouth shadow */}
          <div style={{ position: 'absolute', left: '50%', top: '70%', transform: 'translateX(-50%)', width: 58, height: 10, borderRadius: 20, background: 'radial-gradient(ellipse at 50% 0%, rgba(0,0,0,0.08) 0%, rgba(0,0,0,0.02) 70%, transparent 100%)' }} />
        </div>

        <div className="container about-content py-5" style={{ position: 'relative', zIndex: 4 }}>
          <div className="row">
            <div className="col-lg-8 col-md-10 col-12">
              <h1 className="about-title display-4 fw-bold" style={{ color: '#fff', textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
                UniTrack
              </h1>
              <h2 className="about-subtitle h4" style={{ color: '#e6f0ff', textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>
                AI Attendance, Timesheets, and HR Requests
              </h2>
              <div className="about-underline mt-2" ref={underlineRef}></div>
            </div>
          </div>
        </div>
      </div>

      <section className="py-5 bg-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="card shadow-sm border-0 mb-4">
                <div className="card-body p-4 p-md-5">
                  <p>UniTrack will provide an AI-powered attendance and workforce management platform that generates smart reports, timesheets, and automates HR requests such as vacation and leave approvals.</p>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item px-0"><i className="bi bi-person-badge text-primary me-2"></i>Face/geo-based attendance</li>
                    <li className="list-group-item px-0"><i className="bi bi-calendar2-check text-success me-2"></i>Automated timesheets & approvals</li>
                    <li className="list-group-item px-0"><i className="bi bi-file-bar-graph text-info me-2"></i>Analytics and compliance-ready reports</li>
                    <li className="list-group-item px-0"><i className="bi bi-envelope-paper text-warning me-2"></i>HR requests (vacations, leaves) workflow</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UniTrack;


